import BlockWeatherWidget from '@headlines/components/block/BlockWeatherWidget.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockWeatherWidget: AdminBlockType = {
  component: BlockWeatherWidget,
  attributes: AdminBlockTypeAttributes({
    icons: true,
  }),
  articlesCount: 0,
};

export default AdminBlockWeatherWidget;
